import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { register, uploadImage } from "../../api/axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../assets/logo.png";
import backIcon from "../../assets/backIcon.png";
import googleIcon from "../../assets/googleIcon.svg";
import avatarVector from "../../assets/avatarVector.png";
import Spinner from "../../shared/Spinner/Spinner";
import FieldError from "../../shared/FieldError/FieldError";
import styles from "./Register.module.scss";

const Register = () => {
  const token = localStorage.getItem("authToken");
  const formData = new FormData();
  const navigate = useNavigate();

  // if token exists, then redirect to home
  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [token]);

  // submit loading
  const [loading, setLoading] = useState(false);

  // input states
  const [img, setImg] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // errors
  const [imgError, setImgError] = useState(null);
  const [nameError, setNameError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [phoneError, setPhoneError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState(null);
  const [noMatch, setNoMatch] = useState(null);

  // handle image upload
  const onImageUpload = async (e) => {
    formData.append("file", e.target.files[0]);
    formData.append("upload_preset", "o959yirs");

    const response = await uploadImage(formData);
    if (response.status === 200) {
      setImg(response.data.url);
    } else {
      setImg("error");
    }
  };

  // handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!img) {
      setImgError("Avatar is required!");
    }
    if (!name) {
      setNameError("Full Name is required!");
    }
    if (!email) {
      setEmailError("Email is required!");
    }
    if (!phone) {
      setPhoneError("Phone is required!");
    }
    if (!password) {
      setPasswordError("Password is required!");
    }
    if (!confirmPassword) {
      setConfirmPasswordError("Password is required!");
    }
    if (password !== confirmPassword) {
      setNoMatch("Password do not match!");
    }

    if (
      img &&
      name &&
      email &&
      password &&
      phone &&
      confirmPassword &&
      password === confirmPassword
    ) {
      setLoading(true);
      const payload = {
        userName: name,
        email,
        password,
        mobile: phone,
        profilePic: img,
      };

      const response = await register(payload);
      setLoading(false);
      if (response.status === 200) {
        toast.success(response.data.message);
        navigate("/auth/login");
      } else {
        toast.error(response.data.message);
      }
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.leftContainer} />

      <div className={styles.rightContainer}>
        <img src={logo} alt="logo" className={styles.logo} />
        <form 
        // onSubmit={handleSubmit}
        >
          <h3>
            <img
              src={backIcon}
              alt="go-back"
              className={styles.backIcon}
              onClick={() => navigate("/auth/login")}
            />
            Create a new account
          </h3>
          {img && <img src={img} alt="preview" className={styles.preview} />}
          {!img && (
            <div className={styles.upload}>
              <input
                type="file"
                name="file"
                className={styles.uploadInput}
                onChange={onImageUpload}
              />
              <button type="button" className={styles.uploadBtn}>
                <img
                  src={avatarVector}
                  alt="avatar-vector"
                  className={styles.avatarVector}
                />
                Upload avatar
              </button>
            </div>
          )}
          {/* {imgError && <FieldError message={imgError} />} */}

          <div className={styles.field}>
            <label>Full name</label>
            <input
              type="text"
              name="fullName"
              placeholder="Tyler Smith"
              autoComplete="on"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {/* {nameError && <FieldError message={nameError} />} */}
          </div>
          <div className={styles.field}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              placeholder="johnsnow@gmail.com"
              value={email}
              autoComplete="on"
              onChange={(e) => setEmail(e.target.value)}
            />
            {/* {emailError && <FieldError message={emailError} />} */}
          </div>
          <div className={styles.field}>
            <label>Phone Number</label>
            <input
              type="number"
              name="phone"
              placeholder="2124567890"
              value={phone}
              autoComplete="on"
              onChange={(e) => setPhone(e.target.value)}
            />
            {/* {phoneError && <FieldError message={phoneError} />} */}
          </div>
          <div className={styles.field}>
            <label>Password</label>
            <input
              type="password"
              name="password"
              placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
              value={password}
              autoComplete="off"
              onChange={(e) => setPassword(e.target.value)}
            />
            {/* {passwordError && <FieldError message={passwordError} />} */}
          </div>
          <div className={styles.field}>
            <label>Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
              value={confirmPassword}
              autoComplete="off"
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            {/* {confirmPasswordError && (
              <FieldError message={confirmPasswordError} />
            )}
            {noMatch && <FieldError message={noMatch} />} */}
          </div>
          <small>
            By registering you agree to our <span>Terms & Condition</span> and{" "}
            <span>privacy policy</span>
          </small>

          <div className={styles.btnContainer}>
            <button type="submit">
              {loading ? <Spinner /> : "Create account"}
            </button>
            <button>
              <img src={googleIcon} alt="google" />
              Or sign-up with google
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
